import { axiosConfig } from './axios-config.js'

export const home = {
  // 取得
  get: (token) => axiosConfig.get('/api/console/home-page', token),

  // 更新
  update: (data, token) => axiosConfig.post('/api/console/home-page', data, token)
}
